<template>
    <div>
        <NavTop/>
        <NavDark/>

        <div class="gray py-3 mt-3">
            <div class="container">
                <div class="row">
                    <div class="colxl-12 col-lg-12 col-md-12">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><router-link to="/">Velkommen</router-link></li>
                                <li class="breadcrumb-item active" aria-current="page">Kontakt</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <section class="middle">
            <div class="container">
        
                
                <div class="row align-items-start justify-content-between">
                
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">

                        <div class="sec_title position-relative text-center">
                            <div class="sec_title position-relative text-center" data-bgtext="Kontakt">
                                <h1 class="ft-bold pt-3">Kontakt</h1>
                            </div>
                        </div>

                     
                        
                        <div class="card-wrap-body mb-3">
                            <h4 class="ft-medium mb-3 theme-cl">YOKO er en del af SHUP</h4>
                            <p>Derfor skal al kontakt ske gennem SHUP. Send os en mail på mail@shup.dk</p>
                        <br />
                            </div>

                            <div class="card-wrap-body mb-3">
                            <h4 class="ft-medium mb-3 theme-cl">Send os en mail</h4>
                            <p>På Shup.dk finder du også en Messenger chat nederst til venstre. </p>
                           
                        </div>

  
                        
                        <div class="card-wrap-body mb-3">
                            <h4 class="ft-medium mb-3 theme-cl">Chat med os</h4>
                            <p>På Shup.dk finder du også en Messenger chat nederst til venstre. </p>
                           
                        </div>
                        <div class="card-wrap-body">
                            <div class="address mt-3">
                                Njalsgade 76<br/>2300 København 
                            </div>
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <FooterTopTwo/>
        <FooterDark/>
        <ScrollToTop/>

    </div>
</template>

<script setup>
    import FooterDark from '@/components/footer/footer-dark.vue';
    import FooterTopTwo from '@/components/footer/footer-top-two.vue';
    import NavDark from '@/components/navbar/nav-dark.vue';
    import NavTop from '@/components/navbar/nav-top.vue';
    import ScrollToTop from '@/components/scroll-to-top.vue';
</script>